module.exports = __webpack_public_path__ + "img/richard.b30e82b6.png";